import React from 'react';
import ReactDOM from 'react-dom/client';
// Montserrat is the corporate typeface (Brand Guidelines 2025, "Corporate
// Typeface"). Self-hosted via @fontsource rather than the Google Fonts CDN so
// the app renders correctly on track networks with no outbound internet.
// Weights map to the guidelines: 400 body, 600 subheadings, 700 headings.
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
// Design system tokens + Tailwind utilities.
import './styles/app.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
